import { Box, Typography } from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import Link from "next/link";
import { InsuranceGiftVoucherPromotionActive } from "@/models/AdInsuranceModel";

export function AdInsurancePromotion() {
  if (!InsuranceGiftVoucherPromotionActive()) {
    return null;
  }
  
  return (
    <Box
      component={Link}
      href="/insurance"
      target="_blank"
      rel="noopener noreferrer"
      sx={(theme) => ({
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
        [theme.breakpoints.down("sm")]: {
          order: 2,
          flexDirection: "row",
          gap: 2
        },
      })}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          justifyContent: "center",
        }}
      >
        <CardGiftcardIcon sx={{ fontSize: 40 }} />
        <Box>
          <Typography sx={{ fontWeight: "bold", lineHeight: 1.2 }}>
            FREE $50
            <br />
            fuel card!
          </Typography>
        </Box>
      </Box>
      <Typography variant="caption" sx={{ color: "grey.700" }}>
        with all new policies
        <br />
        in April, T&Cs apply *
      </Typography>
    </Box>
  );
}
